import React, { useState, useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Dashboard from './pages/Dashboard'
import TripHistory from './pages/TripHistory'
import Profile from './pages/Profile'
import Layout from './components/Layout'
import Login from './components/Login'
import Register from './components/Register'

function App() {
  const [user, setUser] = useState(null)
  const [profile, setProfile] = useState(null)
  const [showRegister, setShowRegister] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const token = localStorage.getItem('safenav_token')
    const savedUser = localStorage.getItem('safenav_user')
    const savedProfile = localStorage.getItem('safenav_profile')
    if (token && savedUser) {
      setUser(JSON.parse(savedUser))
      if (savedProfile) setProfile(JSON.parse(savedProfile))
    }
    setLoading(false)
  }, [])

  const handleLogin = (userData, profileData) => {
    setUser(userData)
    setProfile(profileData)
  }

  const handleProfileUpdate = (updatedProfile) => {
    setProfile(updatedProfile)
  }

  const handleLogout = () => {
    localStorage.removeItem('safenav_token')
    localStorage.removeItem('safenav_user')
    localStorage.removeItem('safenav_profile')
    setUser(null)
    setProfile(null)
    setShowRegister(false)
  }

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center">Loading...</div>
  }

  if (!user) {
    return showRegister ? (
      <Register onRegister={handleLogin} onSwitchToLogin={() => setShowRegister(false)} />
    ) : (
      <Login onLogin={handleLogin} onSwitchToRegister={() => setShowRegister(true)} />
    )
  }

  return (
    <Router>
      <Layout user={user} profile={profile} onLogout={handleLogout} onProfileUpdate={handleProfileUpdate}>
        <Routes>
          <Route path="/" element={<Dashboard user={user} profile={profile} />} />
          <Route path="/trips" element={<TripHistory user={user} />} />
          <Route path="/profile" element={<Profile user={user} profile={profile} onProfileUpdate={handleProfileUpdate} />} />
        </Routes>
      </Layout>
    </Router>
  )
}

export default App